import React from 'react';
import { Routes, Route } from 'react-router-dom';
import styled from 'styled-components';

// Import components (to be created)
import Home from './pages/Home';
import NotFound from './pages/NotFound';

const AppContainer = styled.div`
  min-height: 100%;
  display: flex;
  flex-direction: column;
`;

function App() {
  return (
    <AppContainer>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </AppContainer>
  );
}

export default App; 